import React from 'react';
import {
  Button,
  Card,
  CardMedia,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
} from '@material-ui/core';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import DeleteIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';
import PredictionDetails from '../../../components/Camera/PredictionDetails';
import usePredictionsViewDialogHooks from './hooks';
import onKeyClick from '../../../utils/eventListeners';
import CircularLoader from '../../../components/Loaders/CircularLoader';

const PredictionsViewDialog = ({
  classes = {},
  predictionsToView = [],
  predictionsList = [],
  loading,
  onDeleteSamples = () => {},
  onMakePredictionByImage = () => {},
  clearPredictionsList = () => {},
  handleClose = () => {},
  onRelabelSample = () => {},
  currentConfig = 0,
}) => {
  const {
    currentImageNumber,
    totalImages,
    predictionDetails,
    src = '/testIm.jpeg',
    imageLoading,
    onNextClick = () => {},
    onPrevClick = () => {},
    onDeleteSample,
    onRunPrediction,
    onRelabelSampleUuid,
  } = usePredictionsViewDialogHooks(
    predictionsToView,
    loading,
    onDeleteSamples,
    onMakePredictionByImage,
    clearPredictionsList,
    onRelabelSample,
    currentConfig
  );

  const handleKeyboardShortcuts = (e) => {
    onKeyClick(e, 46, onDeleteSample);
    onKeyClick(e, 16, onRelabelSampleUuid);
  };

  return (
    <Dialog
      onKeyUp={handleKeyboardShortcuts}
      fullWidth
      maxWidth="md"
      open={!!predictionsToView.length}
      onClose={handleClose}
    >
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} container justifyContent="center">
            <Grid item>{`Image ${currentImageNumber} of ${totalImages}`}</Grid>
          </Grid>
          <Grid
            item
            xs={12}
            container
            justifyContent="center"
            alignItems="center"
          >
            <Grid item>
              <IconButton
                disableRipple
                style={{ backgroundColor: 'transparent' }}
                onClick={onPrevClick}
              >
                <ArrowLeftIcon style={{ fontSize: '7vw' }} />
              </IconButton>
            </Grid>
            <Grid item xs={7}>
              <Card className={classes.card}>
                <CardMedia className={classes.media}>
                  {imageLoading ? (
                    <CircularLoader />
                  ) : (
                    <img
                      src={src}
                      style={{ height: '100%', width: '100%' }}
                      alt=""
                    />
                  )}
                </CardMedia>
              </Card>
            </Grid>
            <Grid item>
              <IconButton
                disableRipple
                style={{ backgroundColor: 'transparent' }}
                onClick={onNextClick}
              >
                <ArrowRightIcon style={{ fontSize: '7vw' }} />
              </IconButton>
            </Grid>
          </Grid>
          <Grid item xs={12} container justifyContent="center" spacing={2}>
            <Grid item>
              <Button
                size="large"
                className={classes.blueButton}
                variant="contained"
                disabled={loading}
                endIcon={<PhotoCamera />}
                disableElevation
                onClick={onRunPrediction}
              >
                Run prediction
              </Button>
            </Grid>
            <Grid item>
              <Button
                size="large"
                disabled={loading}
                className={classes.darkBlueButton}
                endIcon={<EditIcon />}
                variant="contained"
                disableElevation
                onClick={onRelabelSampleUuid}
              >
                Re-Label
              </Button>
            </Grid>
            <Grid item>
              <Button
                size="large"
                className={classes.redButton}
                variant="contained"
                endIcon={<DeleteIcon />}
                disableElevation
                onClick={onDeleteSample}
              >
                Delete image
              </Button>
            </Grid>
          </Grid>
          <Grid item xs={12} container justifyContent="center">
            <Grid item xs={8}>
              <PredictionDetails
                predictionDetails={predictionDetails}
                predictionsList={predictionsList}
              />
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default PredictionsViewDialog;
